var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.07671 4.86424L8.86404 1.07685C8.9517 0.989247 9 0.872312 9 0.747627C9 0.622941 8.9517 0.506006 8.86404 0.418408L8.58519 0.139492C8.40349 -0.0419999 8.10818 -0.0419999 7.92675 0.139492L4.74638 3.31986L1.56248 0.135963C1.47482 0.0483653 1.35795 -3.34045e-07 1.23333 -3.39492e-07C1.10858 -3.44945e-07 0.991712 0.0483653 0.903975 0.135963L0.625198 0.414879C0.537531 0.502546 0.489235 0.619412 0.489235 0.744097C0.489235 0.868783 0.537531 0.985718 0.625198 1.07332L4.41599 4.86424C4.50393 4.95205 4.62135 5.00028 4.74617 5C4.87148 5.00028 4.98883 4.95205 5.07671 4.86424Z","fill":"#484848"}));
}

ArrowDown.defaultProps = {"width":"9","height":"5","viewBox":"0 0 9 5","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
